import { generator, getFontWeight } from './theme.js';

const fontWeight = (props) => generator({
    props,
    prop: ['fontWeight'],
    cssProperty: 'font-weight',
    getter: getFontWeight,
    transform: (value) => value && value.toString(),
});

export { fontWeight };
